
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    const upsell = document.getElementById('havit-driver-upsell');
    if (upsell) upsell.hidden = true;

    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  async showDriverUpsell(voltage) {
    const upsell = document.getElementById('havit-driver-upsell');
    if (!upsell) return;

    upsell.hidden = true;

    const normalizedVoltage = String(voltage || '').trim().toUpperCase();

    const groups = upsell.querySelectorAll('[data-driver-upsell-group]');

    groups.forEach((group) => {
      group.hidden = true;
    });

    if (!['12V', '24V'].includes(normalizedVoltage)) return;

    const group = Array.from(groups).find(
      (item) => item.dataset.driverUpsellGroup === normalizedVoltage
    );

    if (!group) return;

    const cards = Array.from(
      group.querySelectorAll('[data-driver-product-id]')
    );

    if (!cards.length) return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`);

      if (!response.ok) {
        throw new Error('Could not load cart');
      }

      const cart = await response.json();

      const cartProductIds = new Set(
        cart.items.map((item) => String(item.product_id))
      );

      const driverAlreadyInCart = cards.some(
        (card) => cartProductIds.has(card.dataset.driverProductId)
      );

      if (driverAlreadyInCart) return;

      group.hidden = false;
      upsell.hidden = false;

      console.log('Havit LED driver upsell displayed:', normalizedVoltage);
    } catch (error) {
      console.error('Havit LED driver upsell error:', error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
      .innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
